import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_EXPENSE_URL || 'https://your-api-gateway-url.amazonaws.com/prod';
const user = JSON.parse(localStorage.getItem('user'));
let token;

if (user) {
  token = user.token;
}
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': token
  },
});

export const expenseService = {
  async getRecentExpenses(familyId, filters = {}) {
    const data = { 
      cmd: "getRecent", 
      familyId: familyId,
      data: filters
    };
    const response = await api.post('/expenses', data);
    return response.data;
  },

  async createExpense(expenseData) {
    const response = await api.post('/expenses', { cmd: "create", data: expenseData });
    return response.data;
  },

  async updateExpense(expenseId, updateData, familyId) {
    const data = { 
      cmd: "update", 
      expenseId: expenseId,
      familyId: familyId,
      updateData: updateData
    };
    const response = await api.post('/expenses', data);
    return response.data;
  },

  async deleteExpense(expenseId, familyId) {
    const data = { 
      cmd: "delete", 
      expenseId: expenseId,
      familyId: familyId
    };
    const response = await api.post('/expenses', data);
    return response.data;
  },

  async bulkDeleteExpenses(expenseIds, familyId) {
    const data = { 
      cmd: "bulkDelete", 
      expenseIds: expenseIds,
      familyId: familyId
    };
    const response = await api.post('/expenses', data);
    return response.data;
  },

  async getExpensesByBucket(bucketId) {
    const currentUser = JSON.parse(localStorage.getItem('user'));
    const data = { 
      cmd: "getExpensesByBucket", 
      data: { bucketId },
      user: currentUser
    };
    const response = await api.post('/expenses', data);
    return response.data;
  },

  async importCSV(csvData, template = 'default', templateLabel = 'Default Template', useCsvCategories = false) {
    let data = { 
      cmd: "importCSV", 
      data: csvData, 
      template: template, 
      templateLabel: templateLabel,
      useCsvCategories: useCsvCategories,
      user: user
    }
    const response = await api.post('/expenses', data);
    if (response.data.statusCode && response.data.statusCode > 201) {
      const errMsg = response.data.body;
      throw new Error(errMsg);
    }
    return JSON.parse(response.data.body);
  },

  async getImportTemplate(template = 'default') {
    const response = await api.get(`/expenses/import/template?template=${template}`);
    return response.data;
  }
};